import {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as actions from "./ErrorBoundaryApi"

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
    }

    componentDidCatch(error, info) {
        if (process.env.NODE_ENV === 'development') {
            throw error;
        }
        this.props.actions.logError({
            error: {
                path: window.location.pathname,
                component_stack: info.componentStack,
                message: error.message,
                stack: error.stack
            }
        });
    }

    render() {
        return this.props.children;
    }
}

const mapStateToProps = state => {
}
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
})
export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);